import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { DEFAULT_SETTINGS, setUserSettings } from "@/lib/userSettings";
import { useAuth } from "@/context/AuthContext";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const { user } = useAuth();
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loaded, setLoaded] = useState(false);

  const apply = useCallback((s) => {
    const merged = { ...DEFAULT_SETTINGS, ...(s || {}) };
    setSettings(merged);
    setUserSettings(merged);
  }, []);

  useEffect(() => {
    if (!user) { apply(DEFAULT_SETTINGS); setLoaded(false); return; }
    api.get("/me/settings").then((r) => apply(r.data || {})).catch(() => apply(DEFAULT_SETTINGS)).finally(() => setLoaded(true));
  }, [user, apply]);

  const save = useCallback(async (next) => {
    const merged = { ...DEFAULT_SETTINGS, ...next };
    apply(merged);
    await api.put("/me/settings", { settings: merged });
    return merged;
  }, [apply]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings: apply, save, loaded }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULT_SETTINGS, save: async () => {}, loaded: false };
